/* ============
 * Perimeters State
 * ============
 *
 * The state of the organizations module.
 */

export default {
  all: [],
  allOptions: [],
  allUsers: [],
  pagination: {
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 20,
  },
  paginationUsers: {
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 50,
  },
  selectedPerimeter: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/perimeters/state.js